
import { Component, Vue, Prop } from "vue-property-decorator";
import ContentCard from "../shared/ContentCard.vue";
import AddCompanySection from "../companies/AddCompanySection.vue";
import { Product, Content } from "@authentic-labs/vue-component-library";
import ContentSection from "../../models/ContentSection";
import {
  createSection,
  addCompanySection,
} from "../../services/ContentService";
import { Company, Contentable } from "@authentic-labs/vue-component-library";
import draggable from "vuedraggable";
import User from "../../models/User";
import { filter } from "lodash";

@Component({
  components: {
    ContentCard,
    draggable,
    AddCompanySection,
  },
  filters: {
    capitalizeFirst(value: string) {
      if (value) {
        return value.charAt(0).toUpperCase() + value.substring(1);
      }
    },
  },
})
export default class ContentList extends Vue {
  @Prop()
  isDraggable!: boolean;
  //@Prop()
  //company!: Company;
  @Prop()
  product!: Product;
  @Prop()
  companyContentType!: string;

  get addSectionTitle(): string {
    if (this.disableCreateSections()) {
      return (
        "Your " +
        this.subscription.planType +
        " plan allows for " +
        this.subscription.productSections +
        " sections"
      );
    }
    return "Add another section to your product listing";
  }
  get company(): Company {
    return this.$store.getters.company;
  }
  get user(): User {
    return this.$store.getters.authUser;
  }
  get contentSections() {
    return this.$store.getters.contentSection;
  }
  get paidSections() {
    return this.$store.getters.paidSection;
  }
  get listClass() {
    if (this.product) {
      return "product-list";
    }
    return "company-list";
  }

  get subscription() {
    return this.$store.getters.subscription;
  }

  private _contentable?: Contentable;
  private contentable!: Contentable;
  _changePremiumContent = false;
  private premiumContent?: Content[] = [];

  private signatureContent?: Content[] = [];

  created() {
    this._changePremiumContent = false;
    this.companyContentType
      ? this.updateCompanyContent()
      : (this.contentable = this.product);
  }

  mounted() {
    if (this.product) {
      this.disableCreateSections();
    }
    this.$root.$on("company-section-update", (sectionId: number) => {
      this.updateCompanyContent();
      if (sectionId >= 0) {
        const newSectionIdx = this.contentable.unpublishedContent?.findIndex(
          (elem) => elem.contentSectionId === sectionId
        );
        if (this.contentable.unpublishedContent[newSectionIdx]) {
          this.editSection(
            this.contentable.unpublishedContent[newSectionIdx].id
          );
        }
      }
    });
  }

  updateCompanyContent() {
    this.contentable = this.company;
    if (this.companyContentType === "premium") {
      this.getPremiumContent();
    }
    if (this.companyContentType === "signature") {
      this.getSignatureContent();
    }
  }

  updateSortOrder() {
    if (this.product) {
      this.contentable.unpublishedContent?.forEach((element, index) => {
        element.sortOrder = index;
      });
      this.$store.commit("setProduct", this.contentable);
    }
    if (this.company && this.companyContentType === "premium") {
      const premiumContentArray = this.premiumContent?.map((x) => ({
        sortOrder: x.sortOrder,
        contentSectionId: x.contentSectionId,
      }));
      const copiedPremiumContentArray = JSON.parse(
        JSON.stringify(premiumContentArray)
      );
      copiedPremiumContentArray.sort(
        (a: { sortOrder: number }, b: { sortOrder: number }) =>
          a.sortOrder > b.sortOrder ? 1 : -1
      );
      premiumContentArray?.forEach((element, index) => {
        element.sortOrder = copiedPremiumContentArray![index].sortOrder;
      });
      this.contentable.unpublishedContent.forEach((element) => {
        const filtered = premiumContentArray!.filter(
          (x) => x.contentSectionId === element.contentSectionId
        );
        if (filtered.length > 0) {
          element.sortOrder = filtered[0].sortOrder;
        }
      });
      this.$store.commit("setCompany", this.contentable);
    }
  }

  editSection(contentId: number) {
    if (!this.subscription.isActive) {
      this.$root.$emit("subscription-modal");
      return;
    }
    if (this.companyContentType === "premium" && !this.subscription.isPremium) {
      this.$root.$emit("show-business-upgrade");
      return;
    }
    const index = this.contentable.unpublishedContent.findIndex(
      (p) => p.id === contentId
    );
    this.$root.$emit("show-content-edit", index);
  }

  async confirmDeleteSection(contentId: number) {
    const index = this.contentable.unpublishedContent.findIndex(
      (p) => p.id === contentId
    );
    this.$root.$emit("show-content-confirm", index, contentId);
  }

  disableCreateSections() {
    if (
      this.product.unpublishedContent.length >=
      this.subscription.productSections
    ) {
      return true;
    }
    return false;
  }

  async addProductSection() {
    const content = await createSection(this.contentable);
    if (content.length === 0) {
      this.$root.$emit(
        "alertError",
        "Failed to create a new section, likely exceeded allowed number of sections"
      );
      return;
    }
    const newContentIdx = content.contentable.unpublishedContent.length - 1;
    content.contentable.unpublishedContent[newContentIdx].title = "Title";
    this.$store.commit("setProduct", new Product(content.contentable));
    this.$root.$emit("show-content-edit", newContentIdx);
  }

  getPremiumContent() {
    this.premiumContent = [];
    this.contentable.unpublishedContent.forEach((element) => {
      const paid = this.paidSections.filter(
        (x: ContentSection) => x.id === element.contentSectionId
      );
      if (paid.length > 0) {
        this.premiumContent?.push(element);
      }
    });
  }

  getSignatureContent() {
    this.signatureContent = [];
    this.contentable = this.company;
    this.contentable.unpublishedContent.forEach((element) => {
      const paid = this.paidSections.filter(
        (x: ContentSection) => x.id === element.contentSectionId
      );
      if (paid.length === 0) {
        this.signatureContent?.push(element);
      }
    });
  }

  getFixedSections(sectionId: number) {
    if (this.product) {
      return 0;
    }
    return this.contentSections.find((a: ContentSection) => a.id === sectionId)
      .fixed;
  }

  beforeDestroy() {
    this.$root.$off("company-section-update");
  }
}
